<template>

    <div class="paginator__wrapper">
        <div class="paginator__content">

            <!-- Left arrow -->
            <a @click="goPage(current-1)" class="lateral__move move--button" :class="{blocked: current === firstPage}">
                <i class="icon-anita-arrow-left"></i>
            </a>

            <ul v-if="numPages > 1" class="pages__jumper">

                <!-- SINGLE JUMPER -->
                <li v-if="numPages < 7">
                    <ul>
                        <li v-for="page in range(firstPage, lastPage)" :key="page" :class="{selected: page === current}"  @click="goPage(page)">
                            <a>{{ page }}</a>
                        </li>
                    </ul>

                </li>

                <!-- ADVANCED JUMPER -->
                <li v-else>

                    <ul>

                        <!-- First page -->
                        <li :class="{selected: current === firstPage}" @click="goPage(firstPage)">
                            <a>{{ firstPage }}</a>
                        </li>

                        <!-- Separator -->
                        <li v-if="separator1" ><a>...</a></li>

                        <!-- Middle -->
                        <li v-for="page in middlePages" :class="{selected: current === page}" @click="goPage(page)">
                            <a>{{ page }}</a>
                        </li>

                        <!-- Separator -->
                        <li v-if="separator2" ><a>...</a></li>

                        <!-- Last page -->
                        <li :class="{selected: current === lastPage}" @click="goPage(lastPage)">
                            <a>{{ lastPage }}</a>
                        </li>

                    </ul>

                </li>

            </ul>

            <!-- Rigth arrow -->
            <a @click="goPage(current+1)" class="lateral__move move--button" :class="{blocked: current === lastPage}">
                <i class="icon-anita-arrow-right"></i>
            </a>

        </div>
    </div>

</template>

<style lang="scss" scoped >

</style>

<script>

    const NUMS_BEFORE_AFTER = 1;

    export default {

        props: {
            numPages:    {default: 1, type: Number},
            firstPage:   {default: 1, type: Number},
            currentPage: {default: 1, type: Number},
        },

        data(){

            const lastPage = this.firstPage + this.numPages - 1;
            const current = Math.min(lastPage, Math.max(this.currentPage, this.firstPage));

            return {
                lastPage,
                current,
            };

        },

        computed: {

            middlePages(){
                const start = Math.max(this.firstPage+1, this.current-NUMS_BEFORE_AFTER);
                const end = Math.min(this.lastPage-1, this.current+NUMS_BEFORE_AFTER);
                return this.range(start, end);
            },

            separator1(){
                return this.firstPage < this.current-NUMS_BEFORE_AFTER-1;
            },

            separator2(){
                return this.lastPage > this.current+NUMS_BEFORE_AFTER+1;
            }

        },

        methods: {

            range(start, stop){
                return new Array(stop-start+1).fill(start).map((n,i)=>n+i);
            },

            goPage(page){

                page = Math.min(this.lastPage, Math.max(page, this.firstPage));
                if(this.current === page) return;

                this.current = page;

                this.$emit('goPage', page);

            }

        }
    }

</script>